import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GsAdminShellComponent } from './pages/gs-admin-shell/gs-admin-shell.component';
import { GsSettingsPageComponent } from './pages/gs-settings-page/gs-settings-page.component';

const routes: Routes = [
    {
        path: '',
        component: GsAdminShellComponent,
        children: [
            { path: '',        redirectTo: 'settings', pathMatch: 'full' },
            { path: 'settings', component: GsSettingsPageComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class GrikySkillsAdminRoutingModule {}
